import ServiceAnnouncementsAlert from './ServiceAnnouncementsAlert';

export default ServiceAnnouncementsAlert;



// WEBPACK FOOTER //
// ./src/ondemand/components/ServiceAnnouncementsAlert/index.js